import React from 'react';
import CurrencyFormat from 'react-currency-format';

const AmountConverter = ({ amount }) => {
  return (
    <span>
        £<CurrencyFormat value={parseFloat(amount / 100).toFixed(2)} thousandSeparator={true} displayType={'text'}/>
    </span>    
  );
};

export default AmountConverter;
